import React from 'react';
import { ExternalLink } from 'lucide-react';

const portalLinks = [
  {
    title: "Monitoring Portal",
    description: "Access your monitoring dashboard to view system status and alerts.",
    url: "https://ucx.logicmonitor.com",
    buttonText: "Open Monitoring Portal"
  },
  {
    title: "Remote Support",
    description: "Get immediate remote support from our technical team.",
    url: "https://rmmus-unifiedconnexions.screenconnect.com/?Theme=Embedded",
    buttonText: "Start Remote Session"
  }
];

export default function CustomerPortal() {
  return (
    <div className="pt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Customer Portal</h1>
        <div className="grid md:grid-cols-2 gap-8">
          {portalLinks.map((portal) => (
            <div key={portal.title} className="bg-white rounded-xl shadow-lg p-8 relative group">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl opacity-0 group-hover:opacity-5 transition-opacity"></div>
              <div className="relative">
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{portal.title}</h3>
                <p className="text-gray-600 mb-6">{portal.description}</p>
                <a
                  href={portal.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                >
                  {portal.buttonText}
                  <ExternalLink className="ml-2 h-5 w-5" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}